import type { EAnalyticMode } from '~/core/gemxql';

import { useOrderParameters } from './useOrderParameters';
import { useQueryOrderListing } from '../../api';

interface IUseStoreTotalOrdersProps {
  mode: EAnalyticMode;
}

interface IUseStoreTotalOrdersReturn {
  totalStoreOrders: number;
  refetchStoreTotalOrders: () => void;
}

export const useStoreTotalOrders = ({
  mode,
}: IUseStoreTotalOrdersProps): IUseStoreTotalOrdersReturn => {
  const { parameters } = useOrderParameters({
    metrics: ['orders'],
    isQueryTotal: true,
    mode,
    isSyncSearchParams: false,
  });

  const { total: totalStoreOrders, refetch: refetchStoreTotalOrders } = useQueryOrderListing({
    variables: parameters,
    name: 'OrderListingStoreTotalQL',
  });

  return {
    totalStoreOrders,
    refetchStoreTotalOrders,
  };
};
